import React from 'react';
import './Legal.css';

const PrivacyPolicy: React.FC = () => {
  const lastUpdated = 'November 10, 2024';

  return (
    <section className="legal-page">
      <h1>Privacy Policy</h1>
      <p className="legal-meta">Last updated: {lastUpdated}</p>

      <div className="legal-highlight">
        AI Business Inside provides news and research about AI and business.
        We do not sell user data, and we currently collect only the minimal
        information required to deliver the site (standard web logs and any
        email address you voluntarily submit for updates).
      </div>

      <div className="legal-section">
        <h2>Information We Collect</h2>
        <p>We keep data collection light and transparent:</p>
        <ul>
          <li><strong>Website analytics:</strong> anonymized usage data such as page views and device/browser type, used to understand traffic patterns.</li>
          <li><strong>Voluntary submissions:</strong> your email address and stated preferences if you sign up for updates or contact us directly.</li>
          <li><strong>Logs for security:</strong> standard server logs that help us investigate performance issues or abuse.</li>
        </ul>
      </div>

      <div className="legal-section">
        <h2>How We Use Information</h2>
        <p>Your data is used strictly to:</p>
        <ul>
          <li>deliver site content and maintain performance,</li>
          <li>respond to support or editorial inquiries,</li>
          <li>send optional newsletters or announcements you request,</li>
          <li>keep the platform secure and detect fraud or abuse.</li>
        </ul>
        <p>We may aggregate usage statistics to highlight trends (e.g., most viewed topics), but those summaries cannot identify an individual.</p>
      </div>

      <div className="legal-section">
        <h2>Cookies & Third-Party Services</h2>
        <p>We currently rely on basic analytics cookies and CDN services to keep pages fast. If we introduce advertising or additional analytics partners, we will update this page and provide consent tools when required.</p>
      </div>

      <div className="legal-section">
        <h2>Data Sharing</h2>
        <p>We do not sell or rent your personal information. We may share limited data with trusted providers who help us operate the site (e.g., email delivery services), and only under agreements that require them to safeguard your information.</p>
      </div>

      <div className="legal-section">
        <h2>Your Choices</h2>
        <ul>
          <li>Opt out of emails at any time using the unsubscribe link.</li>
          <li>Contact us to request deletion of your email or inquiry history.</li>
          <li>Use browser controls to manage or block cookies.</li>
        </ul>
      </div>

      <div className="legal-section">
        <h2>Contact</h2>
        <p>Questions about privacy? Email us at <a href="mailto:privacy@aibusinessinside.com">privacy@aibusinessinside.com</a>.</p>
      </div>
    </section>
  );
};

export default PrivacyPolicy;
